<div *ngIf="efastIsShown"  >
    <div class="usa-table-container--scrollable" tabindex="0">
        <table class="usa-table usa-table--striped afs-table-spec">
            <thead>
                <tr>
                    <td>
                    <!-- empty cell for download icon header -->
                    </td>
                    <th *ngFor="let tableSortableHeader of tableSortableHeaders" class={{tableSortableHeader.columnClass}} data-sortable scope="col" role="columnheader" (click)="onSort(tableSortableHeader.sortField)">
                        <span *ngIf="isSortColumnActive(tableSortableHeader.sortField)" class="display:inline-block">
                            <svg *ngIf="isAsc()" class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                <use xlink:href="./assets/img/sprite.svg#arrow_upward"></use>
                            </svg>
                            <svg *ngIf="!isAsc()" class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                <use xlink:href="./assets/img/sprite.svg#arrow_downward"></use>
                            </svg>
                        </span>
                        {{tableSortableHeader.label}}
                    </th>
                </tr>
            </thead>
            <tbody>
            <tr *ngFor="let searchReturn of efastHits.hit">
                <td class="table-padding-spec" scope="row" (click)="pdfClicked(searchReturn.fields.pdfpath)">
                    <svg class="usa-icon text-primary  usa-icon--size-3 afs-cursor-pointer" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="./assets/img/sprite.svg#file_download"></use>
                    </svg>
                </td>
                <td class="table-padding-spec   table-plan-spec" >{{ searchReturn.fields.planname}}
                    <span style="color:blue;font-weight:bold;" *ngIf="searchReturn.fields.dcgind === '1' ">*</span>
                </td>
                
                <td class="table-padding-spec  ">{{ searchReturn.fields.planyear}} </td>
                <td class="table-padding-spec  ">{{ searchReturn.fields.ein | slice:0:2}}-{{ searchReturn.fields.ein | slice:2:searchReturn.fields.ein.length}} <br/> {{ searchReturn.fields.pn}}</td>
                <td class="table-padding-spec  ">{{ searchReturn.fields.datereceived | date:'MM/dd/yyyy':'z'}}</td>
                <td class="table-padding-spec   table-sponsor-spec">{{ searchReturn.fields.plansponsor }}</td>
                <td class="table-padding-spec  ">{{ searchReturn.fields.city}}, <br/> {{searchReturn.fields.state}}{{searchReturn.fields.countrycode}}</td>
                <td class="table-padding-spec   text-right">{{ searchReturn.fields.participantsboy}}</td>
                <td class="table-padding-spec   text-right">{{ searchReturn.fields.assetseoy | currency: 'USD':'symbol':'1.0'}}</td>
            </tr>
            </tbody>
        </table>
    </div>
</div>